import Temp from "@/courier/Temp";

export default class Xpresso extends Temp {
    static CODE = "XPSO";

    constructor() {
        super(Xpresso.CODE);
    }

    static NAMEZONE = {
        GBKK: 1,
    };
      
    static NAMETYPE = {
        GBKK_TO_GBKK: 1,
    };

    getZone(item) {
        let type, to, from;
        let cross_price = 0;
        let remote_area = 0;
        let prefixToPostCode = item.toPostcode.toString().substring(0, 2);
        let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);

        to = super.checkZone(prefixToPostCode);
        from = super.checkZone(prefixFromPostCode);

        if (from == Xpresso.NAMEZONE.GBKK && to == Xpresso.NAMEZONE.GBKK) {
            type = Xpresso.NAMETYPE.GBKK_TO_GBKK;
        }else{
            type = -1
        }

        return {
            rate_type: type,
            rate_remote_area: remote_area,
            cross_price: cross_price,
        };
    }

    checkWeight(courierRates, item, validate) {
        item.index = courierRates.findIndex((rate) => {
            return item.weight >= rate.min && item.weight <= rate.max;
        });

        return super.checkRules(item, validate);
    }

    checkDimension(dimensionCourier, item, validate) {
        return super.checkCourierDimension(dimensionCourier, item, validate);
    }
}
